import { render, staticRenderFns } from "./PlanDetailsCard.vue?vue&type=template&id=687b9760&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('687b9760')) {
      api.createRecord('687b9760', component.options)
    } else {
      api.reload('687b9760', component.options)
    }
    module.hot.accept("./PlanDetailsCard.vue?vue&type=template&id=687b9760&", function () {
      api.rerender('687b9760', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Shared/Updowngrade/PlanDetailsCard.vue"
export default component.exports